// extracted by mini-css-extract-plugin
module.exports = {"TitlePaper":"utils_TitlePaper__1F9qS"};